<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}
.image_right {
  padding-bottom: 40px;
}




</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Magiun #3</p>
      </b-col>
    </b-row>



    <b-row class='content'>
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Hybrid publication, web development, illustration, food writing</p>
        <p>
          Magiun is a magazine about everyday food. It publishes stories, poems, essays, recipes, photos and illustrations.</p>
        <p>
          The <a href="https://magiun.alicestrete.me/">third issue</a> is about routine. The word routine often comes up in association with others like 'boring' or 'drudgery' or 'tedious'. But routines are part of the dynamic of our daily lives. They are personal and can be a real act of care towards ourselves and others. They embody our experiences and our environment, and are therefore an inexhaustible source for self-reflection.</p>
          <p>The print publication was developed and produced in collaboration with Simon Browne, while the cover was printed by Dennis de Bel.</p>




      </div>
      </b-col>
      <b-col md="8">
        <b-row class="image_right">
          <b-col md="8" offset-md="2">
            <b-img class="img-fluid" src="media/magiun3/magiun3_website.png"></b-img>

          </b-col>
        </b-row>



    </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'Magiun3',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
